import React from 'react';
import './IconStyles.css';
import { RiLoopLeftLine } from "react-icons/ri";

export const RenewalMatchingIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
        <RiLoopLeftLine
            color={props.color ? props.color : undefined}
            size={props.size ? props.size : "1.25em"}
        />
    </div>
);
